import React, { Component } from 'react'

// ui
import { Input, DatePicker } from 'antd'

// redux 
import { connect } from 'react-redux'
import ReportActions from '../../../redux/report/actions'

const { Search } = Input
const { MonthPicker, RangePicker, WeekPicker } = DatePicker

class FilterBar extends Component {
    
    _onChangeTime = (e) => {
        try {

            let begin_time = (e[0]._d.valueOf() / 1000) >> 0
            let end_time = (e[1]._d.valueOf() / 1000) >> 0
            this.props.updateTime(begin_time, end_time)
        }
        catch {
            this.props.updateTime(null, null)
        }
    }

    render() {
        return (
            <div className="FilterBar" style={{ minHeight: 100, marginRight: 10 }}>
                <div>
                    Tìm kiếm
                </div>
                <Search
                    className="SearchBox"
                    placeholder="Nhập để tìm kiếm"
                    onSearch={value => this.props.searchReport()}
                    style={{ width: '90%', marginLeft: 'auto', marginRight: 'auto' }}
                    onChange={e => this.props.updateTextSearch(e.target.value)}
                    value={this.props.textSearch}
                />

                <div style={{marginTop: 10}}>
                        Lọc theo khoảng thời gian
                </div>
                <RangePicker onChange={(e) => this._onChangeTime(e)}  style={{marginLeft: 'auto', marginRight: 'auto'}} format={'DD/MM/YYYY'} />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        textSearch: state.qbreport.textSearch
    }
}

const mapDispatchToProps = dispatch => {
    return {
        updateTextSearch: textSearch => {
            dispatch(ReportActions.action.updateTextSearch(textSearch))
        },
        searchReport: () => {
            dispatch(ReportActions.action.searchReport())
        },
        updateTime: (begin_time, end_time) => {
            dispatch(ReportActions.action.updateTime(begin_time, end_time))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FilterBar)